export default __webpack_public_path__ + "static/media/V250_CoC.7cdaf33a.pdf";